import React, { useEffect, useState } from 'react';
import Banner2 from '../../components/Banner2';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import 'react-phone-input-2/lib/plain.css';
import { createProductInquiry } from '../../features/productInquiry';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import MobileNumberInput from '../../components/MobileNumberInput';
import CustomDateRangePicker from '../../components/DateRangePicker';

const ProjectInsurance = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [policyDuration, setPolicyDuration] = useState([null, null]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleInputChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };



  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [startDate, endDate] = policyDuration;

    if (!formData.company_name?.trim())
      newErrors.company_name = t("validation.company_required");

    if (!startDate || !endDate)
      newErrors.policy_duration = t("validation.required");

    if (!formData.contract?.trim())
      newErrors.contract = t("validation.required");

    if (!formData.value_project)
      newErrors.value_project = t("validation.required");

    if (!formData.email) {
      newErrors.email = t("validation.email_required");
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("validation.email_invalid");
    }

    if (!formData.mobile_number)
      newErrors.mobile_number = t("validation.phone_required");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error(t("validation.please_fix_errors"));
      return;
    }

    try {
      const [startDate, endDate] = policyDuration;

      const response = await dispatch(createProductInquiry({
        form_data: {
          ...formData,
          policy_duration: { startDate, endDate }
        },
        product_details: JSON.parse(localStorage.getItem('product_details')),
      })).unwrap();

      if (response.success) {
        toast.success(t('success_res'));
        navigate('/');
      }
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      toast.error(t('error_res'));
    }
  };

  return (
    <>
      <Banner2 classList='bg-grey'>
        <Container>
          <Row>
            <Col className='offset-md-3' md={9}>
              <div className='insurance-title'>
                <h3 className='title text-capitalize text-center'>
                  {t('project_insurance.description')}
                </h3>
              </div>
            </Col>

            <Col md={3}>
              <div className="policy-box">
                <div className="icon-image">
                  <img
                    src={require('../../assets/SVG/1-26.svg').default}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <p className="title">{t('project_insurance.title')}</p>
              </div>
            </Col>

            <Col md={9}>
              <div className="policy-form">
                <div className="policy-formBox why-us-form">
                  <Form onSubmit={handleSubmit}>
                    <Row>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type="text"
                            name="company_name"
                            placeholder={t('project_insurance.form.company_name')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.company_name && (
                            <small className="text-danger">
                              {errors.company_name}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <CustomDateRangePicker
                            name={'policy_duration'}
                            customPlaceHolder={t('project_insurance.form.policy_duration')}
                            onChange={(dates) => setPolicyDuration(dates)}
                            required={true}
                          />
                          {errors.policy_duration && (
                            <small className="text-danger">
                              {errors.policy_duration}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type="text"
                            name="contract"
                            placeholder={t('project_insurance.form.contract')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.contract && (
                            <small className="text-danger">
                              {errors.contract}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type="text"
                            name="value_project"
                            placeholder={t('project_insurance.form.value_project')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.value_project && (
                            <small className="text-danger">
                              {errors.value_project}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder={t('project_insurance.form.email')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.email && (
                            <small className="text-danger">
                              {errors.email}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <MobileNumberInput
                          onChange={({ countryCode, number }) => {
                            handleInputChange("country_code", countryCode);
                            handleInputChange("mobile_number", number);
                          }}
                        />
                        {errors.mobile_number && (
                          <small className="text-danger">
                            {errors.mobile_number}
                          </small>
                        )}
                      </Col>

                      <Col md={12}>
                        <div className='form-submitbtn'>
                          <button type="submit" className="btn h-btn">
                            {t('project_insurance.form.confirm')}
                          </button>
                        </div>
                      </Col>

                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Banner2>
    </>
  );
};

export default ProjectInsurance;